function updateFeatureFlags({ commit }, value) {
  commit('SET_FEATURE_FLAGS', value)
}

export default {
  updateFeatureFlags,
}
